module.exports = "img/icons-close.11ff07c.svg";